import { CheckCircle2, FileText } from "lucide-react";
import PropTypes from "prop-types";
import client from "../../../api/client";
import {
	Button,
	CopyButton,
	Notification,
} from "../../../components/FormComponents";

export default function SuccessScreen({
	proposal,
	onNavigate,
	showNotification,
	notification,
}) {
	const proposalLink =
		proposal.proposal_link ||
		`${window.location.origin}/proposta/${proposal.access_token}`;

	return (
		<div className="max-w-lg mx-auto mt-12">
			<div className="bg-slate-900/50 backdrop-blur border border-green-500/30 rounded-xl p-8 text-center">
				<div className="w-16 h-16 bg-green-600/20 rounded-full flex items-center justify-center mx-auto mb-4">
					<CheckCircle2 className="w-8 h-8 text-green-400" />
				</div>
				<h2 className="text-2xl font-bold text-white mb-2">Proposta Criada!</h2>
				<p className="text-slate-400 mb-6">
					<span className="font-mono text-cyan-400">
						{proposal.proposal?.proposal_number || proposal.proposal_number}
					</span>{" "}
					foi criada com sucesso.
				</p>

				<div className="bg-slate-800/50 rounded-lg p-4 border border-slate-700 mb-6">
					<p className="text-xs text-slate-400 mb-2">Link do cliente:</p>
					<code className="text-xs text-cyan-300 font-mono break-all">
						{proposalLink}
					</code>
				</div>

				<div className="flex gap-3 justify-center">
					<CopyButton text={proposalLink} label="Copiar Link" />
					<Button
						variant="secondary"
						onClick={() => {
							const proposalId = proposal.proposal?.id || proposal.id;
							client
								.post(`/proposals/${proposalId}/send-email`)
								.then(() => {
									showNotification("Email enviado com sucesso!");
								})
								.catch(() => {
									showNotification(
										"Erro ao enviar email (verifique configuracoes SMTP)",
										"error",
									);
								});
						}}
					>
						<FileText className="w-4 h-4 inline mr-1" />
						Enviar Email
					</Button>
				</div>

				<div className="flex gap-3 justify-center mt-6">
					<Button
						variant="ghost"
						onClick={() => onNavigate("/admin/proposals")}
					>
						Ver Propostas
					</Button>
					<Button
						onClick={() =>
							onNavigate(
								`/admin/proposals/${proposal.proposal?.id || proposal.id}`,
							)
						}
					>
						Ver Detalhes
					</Button>
				</div>
			</div>
			<Notification notification={notification} />
		</div>
	);
}

SuccessScreen.propTypes = {
	proposal: PropTypes.object.isRequired,
	onNavigate: PropTypes.func.isRequired,
	showNotification: PropTypes.func.isRequired,
	notification: PropTypes.object,
};
